module.exports = __webpack_public_path__ + "static/media/report-front.d5c5cafc.png";